import React from 'react';
import { Upload, Tooltip, Icon } from 'antd';
import FormItem from '../FormItem/FormItem';

const { Dragger } = Upload;

const normFile = (e) => {
  return Array.isArray(e) ? e : e?.fileList || [];
};

const UploadDraggerField = ({
  form,
  label,
  name,
  decoratorOptions,
  fieldProps = {},
}) => {
  const { getFieldDecorator } = form;

  return (
    <FormItem label={label}>
      {getFieldDecorator(name, {
        ...decoratorOptions,
        valuePropName: 'fileList',
        getValueFromEvent: normFile,
      })(
        <Dragger name="files" beforeUpload={() => false} {...fieldProps}>
          <Tooltip title="Чтобы прикрепить файл, перетащите его сюда, или нажмите чтобы выбрать">
            <Icon type="file-add" theme="outlined" />
          </Tooltip>
        </Dragger>
      )}
    </FormItem>
  );
};

export default UploadDraggerField;
